export default {
  tw: 'tw',
  eu: 'eu'
};
